import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

function UISidebar({ contents, logoSrc }) {
  const { pathname } = useLocation();

  return (
    <nav className="navbar navbar-inverse fixed-top" id="sidebar-wrapper" role="navigation">
      <ul className="nav sidebar-nav">
        <div className="sidebar-header">
          <div className="sidebar-brand">
            {logoSrc
              ? <img className="brand-logo" src={logoSrc} alt="brand" />
              : <span style={{ color: '#fff', fontWeight: 800, fontSize: '1.1rem' }}>🎰 CasinoHub</span>
            }
          </div>
        </div>

        {contents.map((section, i) => (
          <React.Fragment key={i}>
            {section.hidden ? null : section.contents.map((item, j) => (
              <li
                key={`${i}-${j}`}
                className={
                  item.path &&
                  (pathname === item.path || pathname.startsWith(item.path + '/'))
                    ? 'bg-flex-pink'
                    : ''
                }
              >
                {item.linkEl}
              </li>
            ))}
          </React.Fragment>
        ))}
      </ul>
    </nav>
  );
}

UISidebar.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.object),
  logoSrc: PropTypes.string,
};

export default UISidebar;
